"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("events"),
    EventEmitter = _require.EventEmitter;

module.exports =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(VirtualConsole, _EventEmitter);

  function VirtualConsole() {
    var _this;

    _classCallCheck(this, VirtualConsole);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VirtualConsole).call(this));

    _this.on("error", function () {// If "error" event has no listeners,
      // EventEmitter throws an exception
    });

    return _this;
  }

  _createClass(VirtualConsole, [{
    key: "sendTo",
    value: function sendTo(anyConsole, options) {
      var _this2 = this;

      if (options === undefined) {
        options = {};
      }

      var _loop = function _loop() {
        var method = _Object$keys[_i];

        if (typeof anyConsole[method] === "function") {
          var onMethodCall = function onMethodCall() {
            anyConsole[method].apply(anyConsole, arguments);
          };

          _this2.on(method, onMethodCall);
        }
      };

      for (var _i = 0, _Object$keys = Object.keys(anyConsole); _i < _Object$keys.length; _i++) {
        _loop();
      }

      if (!options.omitJSDOMErrors) {
        this.on("jsdomError", function (e) {
          return anyConsole.error(e.stack, e.detail);
        });
      }

      return this;
    }
  }]);

  return VirtualConsole;
}(EventEmitter);